import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { INSTITUTE_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { InstituteEditPage } from '@/features/institutes/pages/InstituteEditPage';
import { instituteListSearchSchema } from '../index';

export const Route = createFileRoute('/_auth/settings/institutes/$instituteId/edit')({
  beforeLoad: () => requirePermission(INSTITUTE_PERMISSIONS.EDIT),
  validateSearch: instituteListSearchSchema,
  component: function EditInstituteRoute() {
    const { instituteId } = Route.useParams();
    return (
      <ErrorBoundary moduleName="Edit Institute">
        <Suspense fallback={<PageLoader />}>
          <InstituteEditPage instituteId={Number(instituteId)} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
